import type { Price } from '~/utils/common';

export enum WishlistActionType {
  ADD_ITEM = 'add_item',
  REMOVE_ITEM = 'remove_item',
}

export interface BaseWishlistAction {
  type: WishlistActionType;
}

export interface Wishlist {
  description: string;
  id: string;
  items: WishlistItem[];
  key: string;
  name: string;
}

export type WishlistAction = WishlistActionAddItem | WishlistActionRemoveItem;

export interface WishlistActionAddItem extends BaseWishlistAction {
  sku: string;
  type: WishlistActionType.ADD_ITEM;
}

export interface WishlistActionRemoveItem extends BaseWishlistAction {
  id: string;
  type: WishlistActionType.REMOVE_ITEM;
}

export interface WishlistItem {
  added_at?: string;
  deactivated_at?: string;
  id: string;
  image_url?: string;
  key?: string;
  name: string;
  prices: Price[];
  sku: string;
  slug?: string;
}

export interface WishlistRequest {
  actions: WishlistAction[];
  country: string;
  id?: string;
  locale?: Locale;
}
